export default __webpack_public_path__ + "static/media/Patrick3_BW.80d44cda.jpg";